import { connect } from 'react-redux'
import { push, goBack } from 'react-router-redux'
import { logout } from '../actions/auth'
import Main from '../components/main'
import { loadUnreadNotifications, loadLocationIssuesCount } from '../actions/auth'
import {
  loadDesktopPreferences,
  loadEmailPreferences
 } from '../actions/settings'

const mapStateToProps = (state, ownProps) => {
  const unreadNotification = state.auth.unreadNotification
  const totalIssues = state.auth.totalIssues

  return {
    unreadNotification,
    totalIssues
  }
}

const mapDispatchToProps = (dispatch, newProps) => {
  dispatch(loadUnreadNotifications())
  dispatch(loadLocationIssuesCount())
  dispatch(loadDesktopPreferences())
  dispatch(loadEmailPreferences())

  return {
  logout () {
    return dispatch(logout())
      .then(() => dispatch(push('/login')))
      .then(() => window.location.reload(true))
  },

  goBack () {
    dispatch(goBack())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main)



// WEBPACK FOOTER //
// ./src/containers/main-container.js